import React from "react";
import "./PublicWall.css";

function PublicWall() {
  const feedItems = [
    {
      id: 1,
      type: "NEW TOURNAMENT",
      typeClass: "tournament",
      time: "1h",
      title: "OC Summer Hoops Classic is now open for registration",
      meta: "Basketball • Orange County • Starts Aug 12",
      action: "View Tournament",
      image: "/wall/oc-summer-hoops.jpg",
    },
    {
      id: 2,
      type: "VERIFIED RESULT",
      typeClass: "verified",
      time: "2h",
      title: "Team Alpha beat Team Legacy 72–68 in FAB Finals",
      meta: "Fast Action Basketball • Spring 2026",
      action: "View Game",
      image: "/wall/fab-result.jpg",
      sideImage: "/wall/scoreboard.jpg",
    },
    {
      id: 3,
      type: "PLAYER MOMENT",
      typeClass: "player",
      time: "4h",
      title: "Stan Chen scored 24 points for Skidmarks",
      meta: "Tustin Columbus Gym League",
      subMeta: "Verified by Fast Action Basketball",
      action: "View Player",
      image: "/wall/player-moment.jpg",
    },
    {
      id: 4,
      type: "LEAGUE UPDATE",
      typeClass: "league",
      time: "6h",
      title: "Coach Anderson started a new Sunday basketball league",
      meta: "Santa Ana, CA • All skill levels welcome",
      action: "View League",
      image: "/wall/sunday-hoops.jpg",
      imageRight: true,
    },
    {
      id: 5,
      type: "CHAMPIONS CROWNED",
      typeClass: "champion",
      time: "1d",
      title: "Westside Elite wins OC Classic Championship!",
      meta: "Great season by all teams",
      action: "View Recap",
      image: "/wall/champions.jpg",
    },
  ];

  return (
    <div className="publicWall-page">
      <div className="publicWall-container">

        <div className="publicWall-header">
          <div>
            <h1>The Wall</h1>
            <p>See what’s happening across local sports.</p>
          </div>

          <div className="publicWall-location">
            Orange County
            <span>⌄</span>
          </div>
        </div>

        <div className="publicWall-filters">
          <button className="publicWall-filter active">
            All Sports
          </button>

          <button className="publicWall-filter">
            Basketball
          </button>

          <button className="publicWall-filter">
            Tennis
          </button>

          <button className="publicWall-filter">
            Soccer
          </button>

          <button className="publicWall-filter">
            Baseball
          </button>

          <button className="publicWall-filter">
            Volleyball
          </button>
        </div>

        <div className="publicWall-feed">
          {feedItems.map((item) => (
            <article
              key={item.id}
              className={`publicWall-card ${item.imageRight ? "image-right" : ""
                }`}
            >
              {item.image && !item.imageRight && (
                <div className="publicWall-card-image">
                  <img
                    src={item.image}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              )}

              <div className="publicWall-card-content">
                <div className="publicWall-card-topline">
                  <span
                    className={`publicWall-card-type ${item.typeClass}`}
                  >
                    {item.type}
                  </span>

                  <span className="publicWall-card-time">
                    {item.time}
                  </span>
                </div>

                <h2>{item.title}</h2>

                <p>{item.meta}</p>

                {item.subMeta && (
                  <div className="publicWall-card-submeta">
                    ✓ {item.subMeta}
                  </div>
                )}

                <button className="publicWall-card-action">
                  {item.action}
                </button>
              </div>

              {item.sideImage && (
                <div className="publicWall-card-side-image">
                  <img
                    src={item.sideImage}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              )}

              {item.imageRight && item.image && (
                <div className="publicWall-card-image publicWall-card-image-right">
                  <img
                    src={item.image}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
              )}
            </article>
          ))}
        </div>

     

      </div>
    </div>
  );
}

export default PublicWall;